import { AbstractResource } from '../../AbstractResource'

class ClassroomResource extends AbstractResource {
  _endpointUrl = '/api/internal/lms/classrooms'
}

export { ClassroomResource }
